v-card.mb-4(outlined)
  v-card-title {{ label }}
  v-card-text
    vue-signature-pad(
      ref="signaturePad"
      width="100%"
      height="200px"
      :options="{ onEnd: handleEnd }"
      style="border: 1px solid #ccc; border-radius: 4px;"
    )
    v-input(v-model="signatureData" :rules="rules")
  v-card-actions
    v-btn(
      @click="clear"
      color="error"
      variant="text"
    ) Clear
